<ng-container *ngIf="countrySelectOptions$ | async as countryOptions; else loading">
  <glxy-select-input
    dense
    required="true"
    [formControl]="countryOptionControl"
    [options]="countryOptions"
    [label]="'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.COUNTRY' | translate"
  ></glxy-select-input>
</ng-container>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
